import { render, staticRenderFns } from "./OrderMailTagExportPageContent.vue?vue&type=template&id=58b966df"
import script from "./OrderMailTagExportPageContent.vue?vue&type=script&lang=js"
export * from "./OrderMailTagExportPageContent.vue?vue&type=script&lang=js"
import style0 from "./OrderMailTagExportPageContent.vue?vue&type=style&index=0&id=58b966df&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports